/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} St_Mock_ApproveInputs */

const en_st_mock_approve = /** @type {(inputs: St_Mock_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approve phase`)
};

const id_st_mock_approve = /** @type {(inputs: St_Mock_ApproveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setujui fase`)
};

/**
* | output |
* | --- |
* | "Approve phase" |
*
* @param {St_Mock_ApproveInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const st_mock_approve = /** @type {((inputs?: St_Mock_ApproveInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<St_Mock_ApproveInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_st_mock_approve(inputs)
	return en_st_mock_approve(inputs)
});